"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _SingleSelection = require("../context/SingleSelection");

var styles = function styles(theme) {
  return {
    root: (0, _defineProperty2["default"])({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    }, theme.breakpoints.up('md'), {
      flexDirection: 'row'
    }),
    fullWidth: {
      '& > *': {
        width: '100%'
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var ToggleButtonGroup = function ToggleButtonGroup(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      fullWidth = _ref.fullWidth,
      children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_SingleSelection.SingleSelectionProvider, {
    value: {
      selected: value,
      onSelect: onChange
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, (0, _defineProperty2["default"])({}, classes.fullWidth, fullWidth))
  }, children));
};

ToggleButtonGroup.propTypes = {
  /** The value of the component. */
  value: _propTypes["default"].any,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired,

  /**
   * Callback fired when the component is changed.
   *
   * **Signature:**
   * ```
   * function(value: any) => void
   * ```
   * *value*: The current value.
   */
  onChange: _propTypes["default"].func.isRequired
};
var _default = ToggleButtonGroup;
exports["default"] = _default;